module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "boy1"
    }
  }, [_c('rect', {
    attrs: {
      "id": "boy1_bag_3",
      "width": "45.91",
      "height": "65.18",
      "x": "1043.28",
      "y": "286.08",
      "fill": "#91713D",
      "transform": "matrix(-1 0 0 1 2132.46 0)",
      "rx": "22.95"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_right_hand",
      "fill": "#BC9555",
      "d": "M1098.06 356.25c.17 1.5 1.16 1.8 2.37 3.46 1.42 1.92 1.66 5.6 3.3 8.57-.3.75-2.74-.35-3.33-1.55-.6-1.2-1.06-2.17-1.25-2.47-.2-.3-.6-.23-.7.08-.1.3.72 11.17.52 11.73-.2.55-1.6.72-1.9.2-.3-.53-1.15-9.1-1.3-9.3-.14-.22-.44-.08-.55.05-.12.14 1.05 9.27.88 9.63-.17.36-1.63.46-1.82.2-.18-.27-1.18-9.38-1.36-9.57-.18-.2-.5-.14-.6.06-.12.2 1.15 8.94.96 9.34-.2.4-1.6.56-1.76.2-.17-.38-1.38-9.18-1.53-9.3-.16-.1-.34-.08-.46.05-.1.14.43 6.75.25 7.14-.2.38-1.26.58-1.46.15-.2-.44-1.12-16.6-1.24-17.48-.38-2.97 1.14-6.27 4.84-6.66 3.7-.4 5.77 2.3 6.12 5.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_right_arm_bottom",
      "fill": "#BC9555",
      "d": "M1089.98 328.56c-3.03.32-5.22 3.06-4.9 6.12l2.3 22.15c.32 3.05 3.03 5.27 6.05 4.95 3.03-.32 5.22-3.06 4.9-6.12l-2.3-22.14c-.32-3.06-3.03-5.28-6.05-4.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_right_arm_top",
      "fill": "#BC9555",
      "d": "M1085.7 289.76c-3.04.32-5.23 3.06-4.9 6.12l4.02 38.75c.32 3.06 3.03 5.28 6.05 4.96 3.03-.33 5.22-3.07 4.9-6.13l-4.02-38.75c-.32-3.06-3.03-5.28-6.06-4.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_right_sleeve",
      "fill": "#FBD79E",
      "d": "M1085.95 289.02c-3.82.4-6.63 3.8-6.37 7.67l1.55 22.43 15.73-1.67-3.1-22.28c-.54-3.84-4-6.57-7.8-6.16z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_right_shoe",
      "fill": "#BC9555",
      "d": "M1090.47 438.7c2.12 1 8.13 3.32 9.58 3.92 1.44.6 3.26 3.3 2.05 5.38h-24.6c-.8-.12-.8-3.22 0-9.3h12.97z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_right_leg_bottom",
      "fill": "#91713D",
      "d": "M1084.06 384.9c-4.24 0-7.67 3.42-7.67 7.67v46.12h15.34v-46.13c0-4.25-3.43-7.68-7.68-7.68z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy1_right_leg_top",
      "width": "15.36",
      "height": "61.04",
      "x": "1076.39",
      "y": "339.36",
      "fill": "#91713D",
      "transform": "matrix(-1 0 0 1 2168.13 0)",
      "rx": "7.68"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_left_shoe",
      "fill": "#BC9555",
      "d": "M1070 438.7c2.1 1 8.12 3.32 9.57 3.92 1.44.6 3.26 3.3 2.05 5.38h-24.6c-.8-.12-.8-3.22 0-9.3H1070z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_left_leg_bottom",
      "fill": "#91713D",
      "d": "M1063.6 384.9c-4.25 0-7.7 3.42-7.7 7.67v46.12h15.37v-46.13c0-4.25-3.44-7.68-7.68-7.68z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_left_leg_top",
      "fill": "#91713D",
      "d": "M1063.6 339.36c-4.25 0-7.7 3.44-7.7 7.68v45.7c0 4.23 3.45 7.67 7.7 7.67 4.23 0 7.67-3.43 7.67-7.67v-45.7c0-4.23-3.44-7.67-7.68-7.67z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_hip",
      "fill": "#91713D",
      "d": "M1091.74 339.36h-35.83v2.78c0 9.9 8.03 17.9 17.93 17.9s17.9-8 17.9-17.9v-2.78z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_torso",
      "fill": "#FBD79E",
      "d": "M1089.14 294.7c-3.8-10.35-28.72-9.9-31.97 0-4.44 13.5-8.45 56.6-7.77 57.7 6.1 9.66 40.5 6.18 45 1.3 1.9-2.1-3.2-53.43-5.26-59z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_bag_2",
      "fill": "#A98448",
      "d": "M1064.4 288.15c-1.72 0-5.54 1.85-5.9 3.4 1.16 12.52 2.9 35.86 3.05 38.15 5.88-3.36 13.5-24.92 2.86-41.55z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_bag_1",
      "fill": "#A98448",
      "d": "M1090.03 295.56c-.8-2.8-3.68-6.05-6.12-6.38 3.17 11.72 7.5 28.82 9.9 39.56-.48-8.98-2.67-29.42-3.77-33.18z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_left_hand",
      "fill": "#BC9555",
      "d": "M1061.23 357.37c0 1.5.96 1.92 2 3.7 1.2 2.05 1.06 5.73 2.4 8.85-.38.72-2.7-.63-3.16-1.9-.47-1.24-.83-2.26-1-2.57-.15-.32-.56-.3-.68 0-.14.3-.46 11.18-.7 11.7-.27.55-1.68.57-1.92 0-.25-.54-.2-9.15-.33-9.38-.12-.23-.43-.12-.56 0-.15.12.08 9.32-.13 9.66-.2.34-1.67.28-1.83 0-.16-.28-.2-9.45-.37-9.66-.16-.2-.48-.18-.6 0-.14.2.22 9.02 0 9.4-.24.37-1.65.38-1.78 0-.14-.4-.43-9.27-.57-9.4-.13-.13-.32-.12-.45 0s-.27 6.75-.5 7.1c-.22.37-1.3.46-1.45 0-.15-.44.6-16.6.58-17.5-.06-3 1.8-6.1 5.5-6.1 3.72 0 5.5 2.9 5.53 6.1z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy1_left_arm_bottom",
      "width": "11.02",
      "height": "33.4",
      "x": "1050.52",
      "y": "329.01",
      "fill": "#BC9555",
      "transform": "matrix(-1 0 0 1 2112.06 0)",
      "rx": "5.51"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "boy1_left_arm_top",
      "width": "11.02",
      "height": "50.1",
      "x": "1050.52",
      "y": "290.22",
      "fill": "#BC9555",
      "transform": "matrix(-1 0 0 1 2112.06 0)",
      "rx": "5.51"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_left_sleeve",
      "fill": "#FBD79E",
      "d": "M1056.2 290.22c-3.85 0-7 3.04-7.14 6.88l-.78 22.55h15.82l-.8-22.55c-.12-3.84-3.27-6.88-7.1-6.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_neck",
      "fill": "#E2B56C",
      "d": "M1079.36 284.07c-.42 2.72-.6 3.8.6 5.3-.2.4-1.5 1.82-3.92 4.3-3.88-2.28-6.17-3.7-6.86-4.3 1.08-1.53 1.02-2.26.38-5.3.8-2.2 8.68-2.12 9.8 0z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "boy1_head"
    }
  }, [_c('path', {
    attrs: {
      "id": "boy1_face",
      "fill": "#E2B56C",
      "fill-rule": "nonzero",
      "d": "M1055.94 265.6c-1.1-.64-2.66-1.46-4.43 0-1.5 1.26-.36 6.18 1.68 8.9 2.03 2.7 5.32 3.27 6.6 2.24 2.74 6.2 9.7 9.5 14.34 9.46 12.43-.1 17.62-12.82 17.62-23.38 0-16.66-6.6-22.27-17.62-22.27-9.9-.05-20.9 5.23-18.18 25.05z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_mouth_bottom",
      "fill": "#D3A862",
      "d": "M1079.76 280.9h-7.95c-.8 0 2.14 1.58 4.8 1.58 2.64 0 3.9-1.58 3.16-1.58z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_mouth_top",
      "fill": "#D3A862",
      "d": "M1080.73 279.9h-9.93c-1.03 0 2.66-2.1 5.97-2.1 3.3 0 4.88 2.1 3.96 2.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_nose",
      "fill": "#D3A862",
      "d": "M1078.27 265.7c0-1.07-2.74-1.16-2.74 0 0 1.18-.88 7.28 0 8.36.88 1.08 3.46.72 3.86 0 .4-.72-1.13-7.28-1.13-8.35z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_right_eye_whites",
      "fill": "#FBD79E",
      "d": "M1079.86 265.7c1.44-3.4 7.85-3.92 8.8-.98.02 3.97-7.75 4.32-8.8.97z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "boy1_right_pupil",
      "cx": "1083.4",
      "cy": "265.54",
      "fill": "#91713D",
      "transform": "matrix(-1 0 0 1 2166.794 0)",
      "rx": "2.2",
      "ry": "2.23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_left_eye_whites",
      "fill": "#FBD79E",
      "d": "M1071.27 265.7c-1.45-3.4-7.86-3.92-8.82-.98 0 3.97 7.77 4.32 8.82.97z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "boy1_left_pupil",
      "cx": "1065.48",
      "cy": "265.54",
      "fill": "#91713D",
      "transform": "matrix(-1 0 0 1 2130.957 0)",
      "rx": "2.2",
      "ry": "2.23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_right_brow",
      "fill": "#BC9555",
      "d": "M1080 261.3c.26-1.4 9-1.43 9.17-.18.18 1.26-1.65.66-4.06.9-2.4.24-5.4.68-5.1-.72z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_left_brow",
      "fill": "#BC9555",
      "d": "M1071.25 261.3c-.28-1.4-9-1.43-9.2-.18-.16 1.26 1.67.66 4.07.9 2.4.24 5.4.68 5.13-.72z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "boy1_hair",
      "fill": "#BC9555",
      "d": "M1089.7 250.8c-2.15-2.1-25.68-1.93-27.52 0-1.85 1.94-2.8 16.92-2.58 19.27.2 2.34-2.3 2.5-2.9.12-.6-2.38-.86-3.23-1.04-4.38-.73-.7-2.46-1.16-3.4-.76-.94-13.38-2.36-26.06 19.36-26.06 14.87 0 17.02 9.2 18.08 11.8z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bbc71a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_2/backgroundCharacters/boyOne.vue
// module id = 671
// module chunks = 1